import { Component, HostBinding } from '@angular/core';
import {RouterLink} from '@angular/router'

@Component({
  selector: 'app-about',
  imports: [RouterLink],
  templateUrl: './about.component.html',
  styleUrl: './about.component.css'
})
export class AboutComponent {
  @HostBinding('class.container') container = true
}
